module.exports = __webpack_public_path__ + "images/675816e340cffb648b913e66d5ed5375.jpg";